import React from "react"
import { Box } from "@mui/material"
import { FaIcon } from "../../../../../../mp-core/icons"
import { Alert } from "../../../"

interface Props {
  type: "no-results" | "narrow"
}

const SearchAlertMessage: React.FC<Props> = ({ type }) => {
  return (
    <Box my={0} mx={1}>
      <Alert
        size="sm"
        icon={
          <FaIcon
            solid
            name={type === "no-results" ? "circle-dashed" : "info-circle"}
          />
        }
      >
        {type === "no-results"
          ? "No results found."
          : "Narrow your search further."}
      </Alert>
    </Box>
  )
}

export default SearchAlertMessage
